import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { BalanceDetailComponent } from 'src/app/modules/balances/pages/balance-detail/balance-detail.page';
import { BalancesListClosedComponent } from 'src/app/modules/balances/pages/balances-list-closed/balances-list-closed.page';
import { BalancesListFirstComponent } from 'src/app/modules/balances/pages/balances-list-first/balances-list-first.page';
import { BalancesListFollowingComponent } from 'src/app/modules/balances/pages/balances-list-following/balances-list-following.page';
import { BalancesListComponent } from 'src/app/modules/balances/pages/balances-list/balances-list.page';
var ɵ0 = {
    permissions: ['canReadBalancesList']
}, ɵ1 = {
    permissions: ['canReadBalancesList']
}, ɵ2 = {
    permissions: ['canReadBalancesList']
}, ɵ3 = {
    permissions: ['canReadBalancesList']
}, ɵ4 = {
    permissions: ['canCreateBalances']
};
// import { AddBalanceComponent } from 'src/app/modules/balances/pages/add-balance/add-balance.page';
var routes = [
    {
        path: 'list',
        component: BalancesListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: 'list-first',
        component: BalancesListFirstComponent,
        canActivate: [RoleGuard],
        data: ɵ1,
    },
    {
        path: 'list-following',
        component: BalancesListFollowingComponent,
        canActivate: [RoleGuard],
        data: ɵ2,
    },
    {
        path: 'list-closed',
        component: BalancesListClosedComponent,
        canActivate: [RoleGuard],
        data: ɵ3,
    },
    {
        path: 'detail/:balanceId',
        component: BalanceDetailComponent,
        canActivate: [RoleGuard],
        data: ɵ4,
    },
    // {
    //   path: 'add',
    //   component: AddBalanceComponent,
    //   canActivate: [RoleGuard],
    //   data: {
    //     permissions: ['canCreateBalances']
    //   },
    // },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var BalancesRoutingModule = /** @class */ (function () {
    function BalancesRoutingModule() {
    }
    return BalancesRoutingModule;
}());
export { BalancesRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
